import { FormError } from 'app/containers/types';
import { GameForm } from '../../types';
import { isValidURL } from 'utils/helpers';

export const validateGame = (form: GameForm): FormError[] => {
  let errors: FormError[] = [];

  if(!form.name.value) {
    errors.push({
      name: "name",
      error: "GAMES.ERRORS.NAME_IS_REQUIRED",
    });
  }

    if (form.endGameLinkLabel?.value || form.endGameLink?.value) {
      if (!form.endGameLinkLabel?.value) {
        errors.push({
          name: "endGameLinkLabel",
          error: "GAMES.ERRORS.LINK_LABEL_IS_REQUIRED",
        });
      }
      
      if (!form.endGameLink?.value) {
        errors.push({ name: "endGameLink", error: "GAMES.ERRORS.LINK_IS_REQUIRED" });
      } else {
        if(String(form.endGameLink?.value).trim().length) {
          if (!isValidURL(form.endGameLink?.value)) {
            errors.push({
              name: "endGameLink",
              error: "GAMES.ERRORS.LINK_SHOULD_BE_VALID",
            });
          }
          
          if (!form.endGameLink?.value.startsWith("https")) {
            errors.push({
              name: "endGameLink",
              error: "GAMES.ERRORS.LINK_SHOULD_START_WITH_HTTP",
            });
          }
      }
      }
  
    }

  return errors;
};
